export const HEADER_MOBILE = 1280;
